import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.baseUrl = environment.apiUrl;
  }

  getUserDetail() {
    return this.http.get(`${this.baseUrl}/api/user/alluser`);
  }
  getDashLink(){
    return this.http.get(`${this.baseUrl}/api/Dashboard_links`);
  }

  getTableauToken(){
    return this.http.get(`${this.baseUrl}/api/tableauToken`);
  }

  createUser(user) {
    return this.http.post(`${this.baseUrl}/api/users`, user);
  }

  deleteUser(id){
    console.log(id)
    return this.http.delete(`${this.baseUrl}/api/user/${id}`)
  }

  updateUser(user) {
    return this.http.post(`${this.baseUrl}/api/users/update`, user);
  }

  updatePasword(user) {
    return this.http.post(`${this.baseUrl}/api/users/reset-password`, user);
  }

  sendResetmail(email) {
    return this.http.post(`${this.baseUrl}/api/users/reset-password-mail`, email);
  }
  searchUser(username){
    return this.http.get(`${this.baseUrl}/api/user/${username}`)
  }
  updateUsername(data){
    return this.http.post(`${this.baseUrl}/api/users/updateUsername`, data)
  }
  findUser(id){
    return this.http.get(`${this.baseUrl}/api/users/${id}`)
  }
  updatePasswordMail(email){
    return this.http.post(`${this.baseUrl}/api/users/updatePasswordMail`,email)
  }
  passwordSuccessMail(mail){
    console.log(mail)
    return this.http.post(`${this.baseUrl}/api/passwordSuccessMail`,mail)
  }
}
